/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { connect } from 'react-redux';
import { resendEmail } from '../../../store/User/userActions';
import MailIcon from '../MailIcon';
import '../style.scoped.scss';
import RegCityLogo from '../RegCityLogo';

const ThankYou = ({ user, resendEmail, resendUserEmail, isApi }) => {
  const handleResend = () => {
    if (user && user.userID) {
      resendEmail(user.userID, user.email);
      resendUserEmail();
    }
  };

  return (
    <div id='thank-you-card'>
      <div className='wf-account__card thank-you pb-0'>
        <RegCityLogo smallerLogo />
        <MailIcon />
        <h3 className='my-4 font-weight-bold text-center'>
          Hi{' '}
          <span className='inner-link'>
            {user && user.firstName ? user.firstName : 'Your First name'}
          </span>
          ,<br />
          {isApi
            ? 'Thank you for joining the RegulationCity API.'
            : 'Thank you for joining RegulationCity.'}
        </h3>

        <b style={{ padding: '1rem 3rem 1rem 3rem' }}>
          {isApi
            ? 'Before you can start building with the RegulationCity API, we just have to verify your email address. We have sent an email to '
            : 'Before you start using RegulationCity, we just have to verify your email address. We have sent an email to '}
          <span className='inner-link'>
            {user && user.email ? user.email : 'your email address'}
          </span>
          .
          {/* (If the email does not appear in your inbox, please check your spam folder) */}{' '}
          Just follow the link provided in the email to complete your
          registration.
        </b>
        <div className='d-flex justify-content-center my-4 borderTop'>
          <b className='mt-4 px-4'>
            Did not receive our email?
            <span className='inner-link' onClick={handleResend}>
              {' '}
              Resend Email Confirmation
            </span>
          </b>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = { resendEmail };

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
